"use strict";
// --------------------------------------------------
// HOUSEHOLD INCOME HELPER
// Return an income string based on
// income and household size
// --------------------------------------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.householdIncome = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
function householdIncome(income, household_size) {
    if (!income) {
        return 'Unknown';
    }
    if ((0, isString_1.default)(income))
        income = parseInt(income, 10);
    if ((0, isString_1.default)(household_size))
        household_size = parseInt(household_size, 10);
    let income_string;
    switch (household_size) {
        case 1:
            if (income < 12000) {
                income_string = 'Below $12,000';
            }
            else if (income >= 12000 && income <= 29000) {
                income_string = '$12,000 - $29,000';
            }
            else if (income > 29000 && income <= 47000) {
                income_string = '$29,001 - $47,000';
            }
            else {
                income_string = 'Over $47,000';
            }
            break;
        case 2:
            if (income < 16000) {
                income_string = 'Below $16,000';
            }
            else if (income >= 16000 && income <= 39000) {
                income_string = '$16,000 - $39,000';
            }
            else if (income > 29000 && income <= 47000) {
                income_string = '$39,001 - $64,000';
            }
            else {
                income_string = 'Over $64,000';
            }
            break;
        case 3:
            if (income < 21000) {
                income_string = 'Below $21,000';
            }
            else if (income >= 21000 && income <= 49000) {
                income_string = '$21,000 - $49,000';
            }
            else if (income > 49000 && income <= 80000) {
                income_string = '$49,001 - $80,000';
            }
            else {
                income_string = 'Over $80,000';
            }
            break;
        case 4:
            if (income < 25000) {
                income_string = 'Below $25,000';
            }
            else if (income >= 25000 && income <= 61000) {
                income_string = '$25,000 - $61,000';
            }
            else if (income > 61000 && income <= 97000) {
                income_string = '$61,001 - $97,000';
            }
            else {
                income_string = 'Over $97,000';
            }
            break;
        case 5:
            if (income < 29000) {
                income_string = 'Below $29,000';
            }
            else if (income >= 29000 && income <= 71000) {
                income_string = '$29,000 - $71,000';
            }
            else if (income > 71000 && income <= 113000) {
                income_string = '$71,001 - $113,000';
            }
            else {
                income_string = 'Over $113,000';
            }
            break;
        case 6:
            if (income < 33000) {
                income_string = 'Below $33,000';
            }
            else if (income >= 33000 && income <= 81000) {
                income_string = '$33,000 - $81,000';
            }
            else if (income > 81000 && income <= 130000) {
                income_string = '$81,001 - $130,000';
            }
            else {
                income_string = 'Over $130,000';
            }
            break;
        case 7:
            if (income < 37000) {
                income_string = 'Below $37,000';
            }
            else if (income >= 37000 && income <= 91000) {
                income_string = '$37,000 - $91,000';
            }
            else if (income > 91000 && income <= 150000) {
                income_string = '$91,001 - $150,000';
            }
            else {
                income_string = 'Over $150,000';
            }
            break;
        case 8:
        case 9:
        case 10:
            if (income < 41000) {
                income_string = 'Below $41,000';
            }
            else if (income >= 41000 && income <= 101000) {
                income_string = '$41,000 - $101,000';
            }
            else if (income > 101000 && income <= 175000) {
                income_string = '$101,001 - $175,000';
            }
            else {
                income_string = 'Over $175,000';
            }
            break;
        default:
            income_string = 'Unknown';
            break;
    }
    return income_string;
}
exports.householdIncome = householdIncome;
